// App
import styled from 'styled-components';
import { stacked } from 'app/shared/styles/_spacing';

export const CheckboxesContainer = styled.div`
  position: relative; // Needed to prevent weird CSS overscrolling issues w/ the checkbox
  ${stacked._1x};
  display: flex;
  align-items: center;
  gap: 8px;
`;
